import { render, staticRenderFns } from "./discoverLanding.vue?vue&type=template&id=0e5fdd3b&"
import script from "./discoverLanding.vue?vue&type=script&lang=js&"
export * from "./discoverLanding.vue?vue&type=script&lang=js&"
import style0 from "./discoverLanding.vue?vue&type=style&index=0&id=0e5fdd3b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports